import { coreContents } from "@/mocks/home";

export default function CoreContent() {
  return (
    <section id="content" className="bg-background-100 border-t border-background-200">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-3xl">
          <span className="text-xs md:text-sm font-medium tracking-wide text-accent-700">
            核心问题
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl font-semibold text-foreground-950 leading-snug">
            姐姐的朋友电影完整版包含哪些内容？
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
            所谓“完整”，通常体现在内容结构是否齐全，而不是单看画质。下面这六项是最常被提及的组成部分，
            它们可以帮助你判断一个版本在内容上是否相对完整。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {coreContents.map((item) => (
            <article
              key={item.id}
              className="flex flex-col rounded-lg bg-background-50 border border-background-200 p-5 md:p-6"
            >
              <div className="flex items-center justify-between">
                <span className="w-11 h-11 rounded-lg bg-accent-100 text-accent-700 flex items-center justify-center">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <span className="font-heading text-2xl font-semibold text-background-400">
                  {item.no}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base md:text-lg font-semibold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}